import { Box } from '@mui/material';
import dayjs from 'dayjs';

import { TourEvent } from '@/domain/project-tour-ontour/entities/project-tour-ontour-event.entity';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';

import { TourEventView } from './TourEventView';

export function ModalTourEventForm({
  open,
  onClose,
  tourEvent,
}: {
  open: boolean;
  onClose: () => void;
  tourEvent: TourEvent;
}) {
  const modalTitle = getModalTitle(tourEvent);
  return (
    <FSModal open={open} onClose={onClose}>
      <FSModalTitle title={modalTitle} />
      <Box sx={{ height: '1rem' }} />
      <TourEventView tourEvent={tourEvent} onClose={onClose} />
    </FSModal>
  );
}

function getModalTitle(tourEvent: TourEvent) {
  return dayjs(tourEvent.date).format('DD/MM/YYYY');
}
